export enum EPaymentItemRateUnit {
  HOUR = "hour",
  PROJECT = "project",
  PIECE = "piece",
}

export const getPaymentItemRateUnitLabel = (
  rateUnit?: EPaymentItemRateUnit,
  quantity: number = 1
) => {
  if (!rateUnit) {
    return undefined;
  }
  switch (rateUnit) {
    case EPaymentItemRateUnit.HOUR:
      return quantity > 1 ? "Hours" : "Hour";
    case EPaymentItemRateUnit.PROJECT:
      return quantity > 1 ? "Projects" : "Project";
    case EPaymentItemRateUnit.PIECE:
      return quantity > 1 ? "Pieces" : "Piece";
    default:
      return undefined;
  }
};
